<template>
  <div class="jy-main-list">
    <div class="jy-main-list-table">
      <div class="button-ground">
        <el-button plain class="jy-button" @click="onDiaCustomerService"
        >客服跟踪</el-button
        >
      </div>
      <div class="form-line"></div>

      <div class="table-ground">
        <div class="contentInner">
          <div class="jy-form-container jy-common-el-tab" style="width: 100%">
            <el-tabs type="border-card" stretch v-model="activeName">
              <el-tab-pane label="运单信息" name="first">
                <div class="jy-line-container">
                  <AngleDouble title="基础信息">
                    <el-form
                        :model="baseInfoForm"
                        label-width="150px"
                        label-position="right"
                    >
                      <el-row :gutter="gutter">
                        <el-col :span="span">
                          <el-form-item
                              label="配载编号："
                              prop="number"
                              class="jy-form-input"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.number"
                                placeholder=""
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="装柜日期："
                              prop="entruckDate"
                              class="jy-form-input"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.entruckDate"
                                placeholder=""
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="柜号/航班号："
                              prop="entruckNo"
                              class="jy-form-input small-button-append"
                          >
                            <el-input v-model="baseInfoForm.entruckNo" disabled>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="是否整柜："
                              class="jy-form-input"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.wholeCabinetType"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="柜型："
                              prop="cabinetType"
                              class="jy-form-select"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.cabinetType"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="柜量："
                              class="jy-form-select"
                              prop="cabinetQuantity"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.cabinetQuantity"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="提单号："
                              prop="takeOrderNumber"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.takeOrderNumber"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="目的国家："
                              class="jy-form-input"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.areaCountry"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="装柜仓库："
                              prop="entruckStorageName"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.entruckStorageName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="到达仓库："
                              prop="arrivalStorageName"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.arrivalStorageName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="起运港："
                              prop="startPort"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.startPort"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="目的港："
                              prop="endPort"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.endPort"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="SO编号："
                              prop="soNumber"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.soNumber"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="船/航空公司："
                              prop="shipAirlinesName"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.shipAirlinesName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="船名/航次："
                              prop="voyageName"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.voyageName"
                            ></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="span">
                          <el-form-item
                              label="ETD："
                              prop="etd"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.etd"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="ETA："
                              prop="eta"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.eta"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="ETB："
                              prop="etb"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.etb"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="运输方式："
                              prop="transportMethod"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.transportMethod"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="订舱合作商："
                              prop="partnerChannleName"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.partnerChannleName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="报关放行日期："
                              prop="customsClearanceDate"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.customsClearanceDate"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="起飞时间："
                              prop="flightDate"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.flightDate"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="创建时间："
                              prop="businessTime"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.businessTime"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="创建人："
                              prop="businessUserName"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.businessUserName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="操作人："
                              prop="recorderUserName"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.recorderUserName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="span">
                          <el-form-item
                              label="备注："
                              prop="remarks"
                              class="jy-form-select flexbox"
                          >
                            <el-input
                                disabled
                                v-model="baseInfoForm.remarks"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </AngleDouble>
                </div>
                <div class="jy-line-container">
                  <AngleDouble title="装柜明细">
                    <div class="table-ground">
                      <el-table
                          class="jy-common-table"
                          header-align="center"
                          border
                          stripe
                          :highlight-current-row="true"
                          style="width: 100%"
                          :data="entruckDetailTable"
                          :summary-method="getSummaries"
                          show-summary
                      >
                        <el-table-column
                            fixed="left"
                            align="center"
                            label="序号"
                            type="index"
                            width="60"
                        ></el-table-column>
<!--                        <el-table-column align="center" type="selection" width="55" ></el-table-column>-->

                        <el-table-column align="center" prop="boxNo" label="箱号">            </el-table-column>
                        <el-table-column align="center" prop="waybillNumber" label="运单号">            </el-table-column>
                        <el-table-column align="center" prop="closeNumber" label="合包单号">            </el-table-column>
                        <el-table-column
                            align="center"
                            prop="memberId"
                            label="会员代码"
                        >
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="userMemberName"
                            label="会员名称"
                        >            </el-table-column>
                        <el-table-column align="center" prop="goodsName" label="产品">            </el-table-column>
                        <el-table-column align="center" prop="packageName" label="包装">            </el-table-column>
                        <el-table-column align="center" prop="closeBillCount" label="合包件数">            </el-table-column>
                        <el-table-column align="center" prop="totalCount" label="件数">            </el-table-column>
                        <el-table-column
                            align="center"
                            prop="totalWeight"
                            label="重量"
                        >            </el-table-column>
                        <el-table-column
                            align="center"
                            prop="totalVolume"
                            label="体积"
                        >            </el-table-column>
                        <el-table-column align="center" prop="specs" label="规格">      </el-table-column>
                        <el-table-column
                            align="center"
                            prop="totalBillingWeight"
                            label="结算重量"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="businessDate"
                            label="开单日期"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="remarks"
                            label="备注"
                        ></el-table-column>
                      </el-table>
                    </div>
                  </AngleDouble>
                </div>

                <div class="jy-line-container">
                  <AngleDouble title="附件信息">
                    <el-table
                        class="jy-common-table"
                        header-align="center"
                        border
                        stripe
                        :highlight-current-row="true"
                        style="width: 100%"
                        :data="annexTable"
                    >
                      <el-table-column
                          fixed="left"
                          align="center"
                          label="序号"
                          type="index"
                          width="60"
                      ></el-table-column>

                      <el-table-column
                          align="center"
                          prop="fileName"
                          label="附件名称"
                      >
                      </el-table-column>
                      <el-table-column
                          align="center"
                          prop="documentType"
                          label="文件类型"
                      >
                      </el-table-column>
                      <el-table-column
                          align="center"
                          prop="createTime"
                          label="上传时间"
                      >
                      </el-table-column>
                      <el-table-column
                          align="center"
                          prop="operationUserName"
                          label="操作人"
                      >
                      </el-table-column>
                      <el-table-column
                          align="center"
                          label="操作"
                          fixed="right"
                          width="180"
                      >
                        <template slot-scope="scope">
                          <el-button link @click="onAnnexOperation(scope)"
                          >查看</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </AngleDouble>
                </div>
              </el-tab-pane>
              <el-tab-pane label="操作日志" name="second">
<!--                <Table-->
<!--                    :tableData="logTableData"-->
<!--                    :theadData="logTheadData"-->
<!--                    :showPagination="false"-->
<!--                    :orderNumber="true"-->
<!--                    :showSearch="false"-->
<!--                    :tableHasTop="false"-->
<!--                    :multiple="false"-->
<!--                    :showSummary="true"-->
<!--                    ref="table2"-->
<!--                    :tableId="table2"-->
<!--                >-->
<!--                </Table>-->
                <el-table
                    :data="logTableData"
                    class="jy-common-table"
                    header-align="center"
                    border
                    stripe
                    :highlight-current-row="true"
                    style="width: 100%"
                >
                  <el-table-column
                      fixed="left"
                      align="center"
                      label="序号"
                      type="index"
                      width="60"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="operatorUserName"
                      label="操作人"
                      width="160"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="operatorTime"
                      label="操作时间"
                      width="200"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="operatorDevice"
                      label="操作设备"
                      width="160"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="operatorDescribe"
                      label="操作内容"
                      width="260"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="comment"
                      label="备注"
                  ></el-table-column>
                </el-table>

              </el-tab-pane>
              <el-tab-pane label="物流轨迹" name="third">
<!--                <Table-->
<!--                    :tableData="trackTableData"-->
<!--                    :theadData="trackTheadData"-->
<!--                    :showPagination="false"-->
<!--                    :orderNumber="true"-->
<!--                    :showSearch="false"-->
<!--                    :tableHasTop="false"-->
<!--                    :multiple="false"-->
<!--                    :showSummary="true"-->
<!--                    ref="table3"-->
<!--                >-->
<!--                </Table>-->
                <el-table
                    :data="trackTableData"
                    class="jy-common-table"
                    header-align="center"
                    border
                    stripe
                    :highlight-current-row="true"
                    style="width: 100%"
                >
                  <el-table-column
                      fixed="left"
                      align="center"
                      label="序号"
                      type="index"
                      width="60"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="operationUserName"
                      label="操作人"
                      width="160"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="operationTime"
                      label="操作时间"
                      width="200"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="title"
                      label="标题"
                      width="160"
                  ></el-table-column>
                  <el-table-column
                      prop="isShowShow"
                      align="center"
                      label="状态"
                      min-width="160"
                  ></el-table-column>
                  <el-table-column
                      align="center"
                      prop="content"
                      label="跟踪信息"
                  ></el-table-column>
                  <el-table-column
                      label="操作"
                      align="center"
                      width="200"
                  >
                    <template slot-scope="scope">
                      <el-button
                          type="text"
                          size="mini"
                          @click="handleEditTrack(scope.row)"
                      >
                        编辑
                      </el-button>
                      <el-button
                          type="text"
                          size="mini"
                          @click="handleDeleteTrack(scope.row)"
                      >
                        删除
                      </el-button>
                      <el-button
                          type="text"
                          size="mini"
                          @click="handleHideTrack(scope.row)"
                      >
                        隐藏
                      </el-button>
                      <el-button
                          type="text"
                          size="mini"
                          @click="handleShowTrack(scope.row)"
                      >
                        展示
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </el-tab-pane>
              <el-tab-pane label="财务信息" name="four">
                <h2 style="margin-top: 0">财务应付</h2>
                <div class="jy-right-form">
<!--                  <Table-->
<!--                      :tableData="financialTable"-->
<!--                      :theadData="financialTh"-->
<!--                      :showPagination="false"-->
<!--                      :orderNumber="true"-->
<!--                      :showSearch="false"-->
<!--                      :tableHasTop="false"-->
<!--                      :multiple="false"-->
<!--                      :showSummary="true"-->
<!--                  >-->
<!--                  </Table>-->
                  <el-table
                      :data="financialTable"
                      class="jy-common-table"
                      header-align="center"
                      border
                      stripe
                      :highlight-current-row="true"
                      style="width: 100%"
                  >
                    <el-table-column
                        fixed="left"
                        align="center"
                        label="序号"
                        type="index"
                        width="60"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="itemCategoryName"
                        label="费项类型"
                        width="120"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="itemServiceName"
                        label="费项"
                        width="100"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="unitPrice"
                        label="单价"
                        width="80"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="amount"
                        label="总价"
                        width="80"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="currency"
                        label="币种"
                        width="80"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="objectStatus"
                        label="结算对象类型"
                        width="150"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="objectName"
                        label="结算对象"
                        width="120"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="paymentMethod"
                        label="付款方式"
                        width="120"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="remarks"
                        label="备注"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="updateUser"
                        label="操作人"
                        width="100"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        prop="updateTime"
                        label="操作时间"
                        width="160"
                    ></el-table-column>

                    <el-table-column
                        align="center"
                        label="附件"
                        width="100"
                    >
                      <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.files && scope.row.files.length > 0"
                            @click="ckfjxxl(scope.row)"
                            type="text"
                        >
                          查看
                        </el-button>
                        <span v-else>无附件</span>
                      </template>
                    </el-table-column>
                  </el-table>

                </div>
              </el-tab-pane>
              <el-tab-pane label="客服跟踪" name="five">
<!--                <Table-->
<!--                    :tableData="customerServiceTableData"-->
<!--                    :theadData="customerServiceTheadData"-->
<!--                    :showPagination="false"-->
<!--                    :orderNumber="true"-->
<!--                    :showSearch="false"-->
<!--                    :tableHasTop="false"-->
<!--                    :multiple="false"-->
<!--                    :showSummary="true"-->
<!--                    ref="table6"-->
<!--                >-->
<!--                </Table>-->
                <el-table
                    :data="customerServiceTableData"
                    class="jy-common-table"
                    header-align="center"
                    border
                    stripe
                    :highlight-current-row="true"
                    style="width: 100%"
                >
                  <el-table-column
                      fixed="left"
                      align="center"
                      label="序号"
                      type="index"
                      width="60"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="number"
                      label="客服跟踪单号"
                      width="160"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="content"
                      label="内容描述"
                      width="200"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="remarks"
                      label="备注"
                      width="160"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="isShow"
                      label="显示在轨迹"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="operationTime"
                      label="发生时间"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="createUserName"
                      label="创建人"
                  ></el-table-column>

                  <el-table-column
                      align="center"
                      prop="createTime"
                      label="创建时间"
                  ></el-table-column>
                </el-table>

              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <customerModelService
        :show="customerModelServiceStatus"
        :documentNumbers="[baseInfoForm.number]"
        documentStatus="bill_tms_entruck_v3:document_status"
        @onCancelCustomerService="onCancelCustomerService"
        @onConfirmCustomerService="onConfirmCustomerService"
        pageType="/pages/v4/entruck/entruckDetails"
        :width="'1180'"
        :dataList="[baseInfoForm]"
    >
    </customerModelService>
    <bigimgs
        :bigImgsShow="bigImgsShow"
        :srcList="srcList"
        @closeDialog="closeDialog"
    ></bigimgs>
    <el-dialog
        title="编辑轨迹"
        :visible.sync="isEditTrackDialogVisible"
        width="50%"
        :close-on-click-modal="false"
        @close="resetEditTrackForm"
    >
      <el-form
          ref="editTrackForm"
          :model="editTrackForm"
          :rules="editTrackRules"
          label-width="80px"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="editTrackForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="轨迹" prop="content">
          <el-input
              v-model="editTrackForm.content"
              type="textarea"
              :rows="4"
              placeholder="请输入轨迹内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="isEditTrackDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitEditTrack">确 定</el-button>
  </span>
    </el-dialog>
  </div>

</template>

<script>
import utils from "@/assets/js/tool";
import customerModelService from "@/components/customerService/modelIndex.vue";
import customerService from "@/components/customerService/index.vue";
import bigimgs from "@/components/lookBigImgs/index.vue";
import { Api } from "@/assets/js/api";
// 详情页排版通用组件
import AngleDouble from '@/components/details/angleDouble.vue';

export default {
  name: "EntruckDetails",
  components: {
    customerModelService,
    customerService,
    bigimgs,
    AngleDouble
  },
  data() {
    return {
      gutter: 12,
      span: 6,
      activeName: "first",
      baseInfoForm: {
        entruckId: "", // 装柜配载id
        number: "", //配载编号
        entruckDate: "", //装柜日期
        entruckNo: "", //柜号/航班号
        wholeCabinetTypeConfDictId: "", //装柜类型id
        wholeCabinetType: "", //装柜类型
        cabinetTypeConfDictId: "", //柜型id
        cabinetType: "", //柜型
        cabinetQuantity: "", //柜量
        areaCountryId: "", //目的国家id
        areaCountry: "", //目的国家
        startPort: "", //起运港
        endPort: "", //目的港
        takeOrderNumber: "", //提单号
        shipAirlinesId: "", //船/航空公司id
        shipAirlinesName: "", //船/航空公司
        voyageName: "", //船名/航次
        soNumber: "", //SO编号
        etd: "", //ETD
        eta: "", //ETA
        etb: "", //ETB
        transportMethodConfDictId: "", //运输方式id
        transportMethod: "", //运输方式
        partnerChannleId: "", //订舱合作商id
        partnerChannleName: "", //订舱合作商
        customsClearanceDate: "", //报关放行日期
        customsCheckDate: "", //报关查验日期
        shipmentDate: "", //起运日期
        entruckStorageId: "", //装柜仓库id
        entruckStorageName: "", //装柜仓库
        arrivalPortDate: "", //到港日期
        touchPortDate: "", //靠港日期
        arrivalStorageId: "", //到达仓库id
        arrivalStorageName: "", //到达仓库
        planIntoStorageTime: "", //预计入仓日期
        intoEndStorageTime: "", //目的仓入仓日期
        businessTime: "", //创建时间
        businessUserName: "", //创建人
        recorderUserId: "",
        recorderUserName: "",
        flightDate: "",
        remarks: "", //备注
      },
      baseInfoRules: {
        entruckDate: [{ required: true, message: "必填", trigger: "blur" }],
        entruckNo: [{ required: true, message: "必填", trigger: "blur" }],
        wholeCabinetTypeConfDictId: [
          { required: true, message: "必填", trigger: "blur" },
        ],
        cabinetType: [{ required: true, message: "必填", trigger: "blur" }],
        cabinetQuantity: [{ required: true, message: "必填", trigger: "blur" }],
        areaCountry: [{ required: true, message: "必填", trigger: "blur" }],
        startPort: [{ required: true, message: "必填", trigger: "blur" }],
        endPort: [{ required: true, message: "必填", trigger: "blur" }],
        takeOrderNumber: [{ required: true, message: "必填", trigger: "blur" }],
        shipAirlinesId: [{ required: true, message: "必填", trigger: "blur" }],
        soNumber: [{ required: true, message: "必填", trigger: "blur" }],
        etd: [{ required: true, message: "必填", trigger: "blur" }],
        eta: [{ required: true, message: "必填", trigger: "blur" }],
        transportMethod: [{ required: true, message: "必填", trigger: "blur" }],
      },
      financialTh: [
        {
          fieldNameShow: "费项类型",
          fieldAlias: "itemCategoryName",
          wide: 120,
        },
        {
          fieldNameShow: "费项",
          fieldAlias: "itemServiceName",
          wide: 100,
        },
        {
          fieldNameShow: "单价",
          fieldAlias: "unitPrice",
          wide: 80,
        },
        {
          fieldNameShow: "总价",
          fieldAlias: "amount",
          wide: 80,
        },
        {
          fieldNameShow: "币种",
          fieldAlias: "currency",
          wide: 80,
        },
        {
          fieldNameShow: "结算对象类型",
          fieldAlias: "objectStatus",
          wide: 150,
        },
        {
          fieldNameShow: "结算对象",
          fieldAlias: "objectName",
          wide: 120,
        },
        {
          fieldNameShow: "付款方式",
          fieldAlias: "paymentMethod",
          wide: 120,
        },
        {
          fieldNameShow: "备注",
          fieldAlias: "remarks",
        },
        {
          fieldNameShow: "操作人",
          fieldAlias: "updateUser",
          wide: 100,
        },
        {
          fieldNameShow: "操作时间",
          fieldAlias: "updateTime",
          wide: 160,
        },
        // 添加操作列
        {
          fieldNameShow: "操作",
          fieldAlias: "action",
          wide: 100,
          type: "action", // 如果 Table 组件支持 action 类型
          buttons: [
            {
              name: "查看附件",
              method: "ckfjxxl",
              show: (row) => row.files && row.files.length > 0 // 只在有附件时显示
            }
          ]
        }
      ],
      // 附件信息
      annexTable: [],
      logTheadData: [
        {
          fieldNameShow: "操作人",
          fieldAlias: "operatorUserName",
          width: 160,
        },
        {
          fieldNameShow: "操作时间",
          fieldAlias: "operatorTime",
          width: 200,
        },
        {
          fieldNameShow: "操作设备",
          fieldAlias: "operatorDevice",
          width: 160,
        },
        {
          fieldNameShow: "操作内容",
          fieldAlias: "operatorDescribe",
          width: 260,
        },
        {
          fieldNameShow: "备注",
          fieldAlias: "comment",
        },
      ],
      // 财务信息
      financialTable: [],
      logTableData: [],
      trackTheadData: [
        {
          fieldNameShow: "操作人",
          fieldAlias: "operationUserName",
          width: 160,
        },
        {
          fieldNameShow: "操作时间",
          fieldAlias: "operationTime",
          width: 200,
        },
        {
          fieldNameShow: "订单状态",
          fieldAlias: "title",
          width: 160,
        },
        {
          fieldNameShow: "跟踪信息",
          fieldAlias: "content",
        },
      ],
      trackTableData: [],
      customerServiceStatus: false,
      kfTrackVersion: "v1",
      customerModelServiceStatus: false,
      entruckDetailTable: [],
      totlaList: [
        "totalCount",
        "totalGrossWeight",
        "totalGrossVolume",
        "totalSettlementWeight",
        "totalSettlementVolume"
      ],
      // 客服追踪
      customerServiceTheadData: [
        {
          fieldNameShow: "客服跟踪单号",
          fieldAlias: "number",
          width: 160,
        },
        {
          fieldNameShow: "内容描述",
          fieldAlias: "content",
          width: 200,
        },
        {
          fieldNameShow: "备注",
          fieldAlias: "remarks",
          width: 160,
        },
        {
          fieldNameShow: "显示在轨迹",
          fieldAlias: "isShow",
        },
        {
          fieldNameShow: "发生时间",
          fieldAlias: "operationTime",
        },
        {
          fieldNameShow: "创建人",
          fieldAlias: "createUserName",
        },
        {
          fieldNameShow: "创建时间",
          fieldAlias: "createTime",
        },
      ],
      bigImgsShow: false,
      srcList: [],
      customerServiceTableData: [],
      isEditTrackDialogVisible: false, // 编辑轨迹弹窗显示状态
      editTrackForm: {
        trackId: '',
        title: '',
        content: ''
      },
      editTrackRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入轨迹内容', trigger: 'blur' }]
      },
      entruckId: "",
    };
  },
  watch: {
    $route: {
      handler(newVal) {
        if (newVal.query && newVal.query.id && newVal.query.status === "readonly") {
          this.entruckId = newVal.query.id;
          this.getDetailsData(newVal.query.id);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.windowResize();
    window.onresize = () => {
      this.windowResize();
    };
  },
  methods: {

    async getTrackData() {
      // 装柜配载 - 物流轨迹

      let obj = {
        conditonKey: "entruckId",
        conditonVal: this.entruckId,
      };
      let params4 = {
        conditionReqs: [obj],
        number: "entruck_detail_track_transport",
      };
      await Api.runReport(params4).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) === "Array") {
              this.trackTableData = datas;
            }
          }
        }
      });
    },

    // 根据分辨率 调整表单宽度
    windowResize() {
      let clientWidth = document.body.clientWidth;
      if (clientWidth <= 1760) {
        this.span = 8;
      } else {
        this.span = 6;
      }
    },
    onAnnexOperation(row) {
      const item = row.row;
      if (item.fileId) {
        Api.getFileUrl({ fileName: item.fileId }).then((res) => {
          let filse = res.data.result || {};
          if (filse.url) {
            window.open(filse.url, "_blank");
          } else {
            this.$message({
              message: "打开失败,没有检测到图片地址",
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "附件ID不存在！",
          type: "error",
        });
      }
    },
    // 获取合计数据
    getSummaries(param) {
      return utils.utilsgetSummaries(param, this.totlaList);
    },
    onDiaCustomerService() {
      //获取客服跟踪版本
      this.customerModelServiceStatus = true;
    },
    onCancelCustomerService() {
      this.customerServiceStatus = false;
      this.customerModelServiceStatus = false;
    },
    onConfirmCustomerService(obj) {
      console.log(obj);
      this.customerServiceStatus = false;
      this.customerModelServiceStatus = false;
    },
    closeDialog(e) {
      this.bigImgsShow = false;
    },
    ckfjxxl(row) {
      this.srcList = [];
      if (utils.jyCheckObjectType(row.files) === "Array") {
        if (row.files.length > 0) {
          const promises = row.files.map(obj =>
              Api.getFileUrl({ fileName: obj.fileId }).then((res) => {
                let filse = res.data.result || {};
                if (filse.url) {
                  obj.url = filse.url;
                } else {
                  this.$message({
                    message: "附件地址获取失败",
                    type: "error",
                  });
                }
              })
          );

          Promise.all(promises).then(() => {
            let arr = row.files.map((imtes) => {
              return imtes.url;
            });
            this.srcList = arr;
            this.bigImgsShow = true;
          });
        } else {
          this.$message({
            message: "附件不存在",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "附件不存在",
          type: "error",
        });
      }
    },
    // 查询详情页数据  -- begin
    async getDetailsData(id) {
      let obj = {
        conditonKey: "entruckId",
        conditonVal: id,
      };
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中...", //可以自定义文字
        background: "rgba(255, 255, 255, 0)", //遮罩层背景色
      });
      // 装柜配载详情
      let params1 = {
        conditionReqs: [obj],
        number: "entruck_detail",
      };
      await Api.runReport(params1).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) === "Array") {
              const obj = datas[0];
              // 基本信息
              utils.oldObjToNewObj(this.baseInfoForm, obj);
            }
          }
        }
      });

      let itemParam = {
        conditionReqs: [obj],
        number: "entruck_detail_item",
      };
      this.entruckDetailTable = [];
      await Api.runReport(itemParam).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) == "Array") {
              this.entruckDetailTable = datas;
            }
          }
        }
      });

      loading.close();
      // 装柜配载详情-附件
      let params2 = {
        conditionReqs: [obj],
        number: "entruck_detail_file",
      };
      await Api.runReport(params2).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) === "Array") {
              datas.forEach((item) => {
                item.operationType = "UPDATE";
              });
              this.annexTable = datas;
            }
          }
        }
      });

      // 装柜配载 - 操作日志
      let params3 = {
        conditionReqs: [obj],
        number: "entruck_detail_log",
      };
      await Api.runReport(params3).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) === "Array") {
              this.logTableData = datas;
            }
          }
        }
      });

      // 装柜配载 - 物流轨迹
      let params4 = {
        conditionReqs: [obj],
        number: "entruck_detail_track_transport",
      };
      await Api.runReport(params4).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) === "Array") {
              this.trackTableData = datas;
            }
          }
        }
      });

      // 装柜配载详情-财务信息
      let params5 = {
        conditionReqs: [obj],
        number: "entruck_detail_finance",
      };
      let caiWuXinXiList = [];
      await Api.runReport(params5).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) === "Array") {
              // this.financialTable = datas;
              caiWuXinXiList = datas;
            }
          }
        }
      });

      // 财务信息附件
      let params5_1 = {
        conditionReqs: [obj],
        number: "entruck_detail_finance_file",
      };
      let caiWuXinXiFuJianList = [];
      await Api.runReport(params5_1).then((res) => {
        const data = res.data;
        if (data.status === "success") {
          let result = data.result;
          const datas = result.datas;
          if (utils.jyCheckObjectType(datas) === "Array") {
            caiWuXinXiFuJianList = datas;
          }
        }
      });

      caiWuXinXiList.forEach((value, key) => {
        let arr = [];
        caiWuXinXiFuJianList.forEach((item, index) => {
          if (value.id === item.financeItemServiceId) {
            item.name = item.fileId;
            item.status = "success";
            arr.push(item);
          }
        });
        value.files = arr;
      });
      this.financialTable = caiWuXinXiList;

      // 装柜配载详情-客服
      let params6 = {
        conditionReqs: [obj],
        number: "entruck_detail_bill_kf_track_record",
      };
      await Api.runReport(params6).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) === "Array") {
              this.customerServiceTableData = datas;
            }
          }
        }
      });
      loading.close();
    },

    // 编辑轨迹操作
    handleEditTrack(row) {
      // 带出当前行数据到表单
      this.editTrackForm = {
        trackId: row.id || '',
        title: row.title || '',
        content: row.content || ''
      };
      this.isEditTrackDialogVisible = true;
    },

    // 重置编辑表单
    resetEditTrackForm() {
      this.$refs.editTrackForm && this.$refs.editTrackForm.resetFields();
      this.editTrackForm = {
        trackId: '',
        createTime: '',
        title: '',
        content: ''
      };
    },

    // 提交编辑
    submitEditTrack() {
      this.$refs.editTrackForm.validate((valid) => {
        if (valid) {
          // 构造提交参数
          let param = {
            trackId: this.editTrackForm.trackId,
            title: this.editTrackForm.title,
            content: this.editTrackForm.content
          };

          // 调用API提交修改
          Api.updateTrack(param).then((res) => {
            if (res.data.status === "success") {
              this.$message.success(res.data.message);
              this.isEditTrackDialogVisible = false;
              // 刷新轨迹列表
              this.getTrackData();
            } else {
              this.$message.error(res.data.message);
            }
          }).catch((error) => {
            this.$message.error('修改失败');
          });
        }
      });
    },


    // 删除轨迹操作
    handleDeleteTrack(row) {
      this.$confirm('确定要删除这条轨迹记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          trackIds: [row.id]
        };
        // 实现删除轨迹逻辑
        Api.delTrack(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.getTrackData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    // 隐藏轨迹操作
    handleHideTrack(row) {
      this.$confirm('确定要隐藏这条轨迹记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          trackIds: [row.id]
        };
        // 实现隐藏轨迹逻辑
        Api.notShowTrack(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.getTrackData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {
        this.$message.info('已取消隐藏');
      });
    },

    // 展示轨迹操作
    handleShowTrack(row) {
      // 实现展示轨迹逻辑
      this.$confirm('确定要展示这条轨迹记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          trackIds: [row.id]
        };
        // 实现展示轨迹逻辑
        Api.showTrack(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.getTrackData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {
        this.$message.info('已取消展示');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.jy-form-container {
  padding: 0px;
  background: #fff;
  border-radius: 6px;
}

.form-line {
  margin-top: 20px;
  height: 1px;
  background: #ccc;
}

.tag-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tag-list {
  display: flex;
  margin-top: 15px;

  .tag-span {
    width: 80px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    border: 2px dashed red;
    color: red;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}

.jy-main-list {
  height: 100%;
  overflow: hidden;
}

.jy-main-list-table {
  // margin-top: 15px;
  padding: 10px;
  background: #fff;
  height: 100%;
  overflow: hidden;
}

.jy-main-list-topform {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-box {
  display: flex;
}

.operate-list {
  display: flex;

  ::v-deep(.el-button) {
    margin: 0;
    margin-left: 5px;
  }
}

.jy-main-list-top {
  padding: 10px;
  background: #fff;
  height: auto;
  overflow: hidden;

  &.hiddenStyle {
    height: 60px;
  }
}

.iconrotate {
  transform: rotate(180deg);
}

.table-parent-box {
  height: 100%;
}

.table-ground {
  margin-top: 15px;
  height: calc(100% - 67px);
  overflow: hidden;
}

.contentInner {
  width: 100%;
  display: flex;
  height: 100%;

  .leftInner {
    width: 200px;
    margin-right: 16px;
    height: 100%;
  }

  .rightInner {
    flex: 1;
    height: 100%;
  }
}

.formborder {
  border: 1px solid #ebeeff;
  padding: 10px;
  border-radius: 3px;
}
</style>
